import React, { useEffect, useState, useMemo } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import { } from '@lockerpm/design';

import commonComponents from "../../../components/common";
import itemsComponents from "../../../components/items";

import Filter from "./components/Filter";
import TableData from "./components/TableData";
import BoxData from "./components/BoxData";

import global from "../../../config/global";
import workspaceServices from "../../../services/workspace";
import resourceServices from "../../../services/resource";
import { getRouterByLocation, scrollEnd } from '../../../utils/common';

const WorkspaceAccessLog = (props) => {
  const { t } = useTranslation()
  const { PageHeader } = commonComponents;
  const { NoData, Pagination} = itemsComponents;

  const isMobile = useSelector((state) => state.system.isMobile)
  const locale = useSelector((state) => state.system.locale)

  const currentPage = getRouterByLocation(window.location);
  const [loading, setLoading] = useState(false);
  const [accessLogClients, setAccessLogClients] = useState([]);
  const [total, setTotal] = useState(0);
  const [allTotal, setAllTotal] = useState(0);
  const [data, setData] = useState([]);
  const [params, setParams] = useState({
    page: 1,
    size: global.constants.PAGE_SIZE,
    projectIds: []
  });

  const payload = useMemo(() => {
    if (params?.projectIds?.length > 0) {
      return {
        ...params,
        project_ids: params.projectIds.join(',')
      }
    }
    return {
      ...params,
      projectIds: undefined
    }
  }, [JSON.stringify(params)])

  useEffect(() => {
    getAllTotal()
    fetchAccessLogClients()
  }, [])

  useEffect(() => {
    fetchData()
  }, [payload])
  
  useEffect(() => {
    setParams({
      ...params,
      page: 1,
      size: global.constants.PAGE_SIZE
    })
  }, [isMobile])

  const handleChangePage = (page, size) => {
    setParams({
      ...params,
      page,
      size
    })
  };

  const fetchAccessLogClients = () => {
    resourceServices.list_access_log_clients().then((response) => {
      setAccessLogClients(response);
    }).catch(() => {
      setAccessLogClients([])
    })
  }

  const getAllTotal = async () => {
    await workspaceServices.access_logs(currentPage.params?.workspace_id, {page: 1, size: 1}).then((response) => {
      setAllTotal(response.count)
    }).catch(() => {
      setAllTotal(0)
    })
  }

  const fetchData = () => {
    setLoading(true)
    workspaceServices.access_logs(
      currentPage.params?.workspace_id,
      payload
    ).then((response) => {
      setData(response.results);
      setTotal(response.count)
      setLoading(false)
    }).catch(() => {
      setData([])
      setTotal(0)
      setLoading(false)
    })
  }

  return (
    <div
      className="access-log layout-content"
      onScroll={(e) => scrollEnd(e, params, total, setParams)}
    >
      <PageHeader
        title={t('events.title')}
        subtitle={t('events.description')}
        docLabel={t('events.doc')}
        docLink={global.urls.DOC_LINKS[locale].WS_EVENTS}
        actions={[]}
      />
      {
        allTotal > 0 && <Filter
          className={'mt-6'}
          params={params}
          accessLogClients={accessLogClients}
          setParams={(v) => setParams({ ...v, page: 1 })}
        />
      }
      {
        total == 0 && <NoData
          loading={loading}
          className={'mt-6'}
        />
      }
      {
        total > 0 && <>
          {
            isMobile ? <BoxData
              className="mt-4"
              loading={loading}
              data={data}
              params={params}
              accessLogClients={accessLogClients}
            /> : <TableData
              className="mt-4"
              loading={loading}
              data={data}
              params={params}
              accessLogClients={accessLogClients}
            />
          }
        </>
      }
      {
        total > global.constants.PAGE_SIZE && !isMobile && <Pagination
          params={params}
          total={total}
          onChange={handleChangePage}
        />
      }
    </div>
  );
}

export default WorkspaceAccessLog;